import { uid } from '../../../../lib/uid';
import type { SurveyTrainingRecommendationRequest } from '../surveyTypes';

/** One row of a Training Recommendations grid. Plain text in both cells. */
export interface DraftTraining {
  key: string;
  title: string;
  details: string;
}

export const blankTraining = (): DraftTraining => ({ key: uid(), title: '', details: '' });

/** Nothing on the row — the blank row a grid always holds, left out on save. */
export const isBlankTraining = (t: DraftTraining) => t.title.trim() === '' && t.details.trim() === '';

/** A recommendation with no title — one nobody could find in its table. */
export const isUntitledTraining = (t: DraftTraining) => t.title.trim() === '' && t.details.trim() !== '';

const escapeHtml = (text: string) => text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

/** What a row sends: a cell holds plain text, the column holds a document, so it is wrapped once here. */
export const toTrainingRequest = (t: DraftTraining): SurveyTrainingRecommendationRequest => ({
  title: t.title.trim(),
  details: t.details.trim() === '' ? '' : `<p>${escapeHtml(t.details.trim())}</p>`,
});
